export default {"src":"/_next/static/media/student-reliability.63df41fd.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};